import { useQuery } from '@tanstack/react-query';
import type { BoundaryStragglerAlertDto } from '@signalvote/shared';
import { apiJson } from './apiFetch';
import { queryKeys } from '../../lib/queryKeys';

// ============================================================================
// Plaid bank-pull — the boundary-straggler treasurer surface (ADR-071 amendment, #575),
// against `api/finance/straggler-alerts`.
//
// The straggler catch now LANDS a synced line that dates into an already-closed period on the
// all-time ledger as an Unattributed, closed-period row (the amber "Needs amendment" band). This
// hook reads the OPEN alerts (a proper CampaignId-scoped read path — never hand-filtering raw audit
// rows on the FE) so the close-hub card can HIGHLIGHT which transaction / how much / which period,
// and deep-link into the existing amend flow. There is no acknowledge mutation — an alert closes
// when its landed ledger row is classified or excluded (the ledger's own vocabulary), so the card
// simply reflects the live open set (the #565 "Mark handled" acknowledge was retired).
// ============================================================================

/**
 * Lists the campaign's OPEN boundary-straggler alerts for the close-hub highlight. Empty (and so the
 * card renders nothing) when there are none. Classifying / excluding the landed ledger row closes the
 * alert server-side, so a sort-inbox invalidation naturally refreshes this too.
 */
export function useStragglerAlerts() {
  return useQuery({
    queryKey: queryKeys.finance.stragglerAlerts(),
    queryFn: (): Promise<BoundaryStragglerAlertDto[]> =>
      apiJson<BoundaryStragglerAlertDto[]>('/api/finance/straggler-alerts', {
        method: 'GET',
        error: (body) => new Error(body.error || 'Failed to load bank straggler alerts'),
      }),
  });
}
